export const NUMBER_SLIDE_SIZE = {
    DEFAULT: 'default',
    SMALL: 'small',
    LARGE: 'large',
    WORKBENCH_TOOLBAR: 'workbench_toolbar',
};
